import React from "react";

function ChatGpt(props) {
  return (
    <div>
      <h3>Dashboard chatgpt page in progress</h3>
    </div>
  );
}

export default ChatGpt;
